module.exports = __webpack_public_path__ + "static/bg2-f7547eccabe3c7a5427f369e7b560269.jpg";